import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
// import { IonicStorageModule } from "@ionic/storage";
import { HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SocketIoModule, SocketIoConfig } from "ngx-socket-io";
// import { NOTIFICATION_SOCKET_PORT } from 'src/environments/environment';
import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";
import { Camera } from "@ionic-native/camera/ngx";
// const config: SocketIoConfig = { url: NOTIFICATION_SOCKET_PORT, options: {} };

import { Geolocation } from "@ionic-native/geolocation/ngx";
import { NativeGeocoder } from "@ionic-native/native-geocoder/ngx";

// const config: SocketIoConfig = { url: chatDomain, options: {} };
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    // IonicStorageModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    // SocketIoModule.forRoot(config),
  ],
  providers: [
    InAppBrowser,
    StatusBar,
    SplashScreen,
    Camera,
    Geolocation,
    NativeGeocoder,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
